import React from 'react';
import styles from './MediaWatermark.module.css';

// Envuelve una imagen o video aplicando marca de agua (overlay) y medidas
// anti-descarga: sin menú contextual, sin arrastre, sin selección, sin PiP
// ni botón de descarga en el reproductor de video.
const MediaWatermark = ({ item, watermarkText = 'By Raíces' }) => {
  if (!item?.url) return null;

  const preventContext = (e) => e.preventDefault();

  return (
    <div className={styles.wrap} onContextMenu={preventContext}>
      {item.type === 'video' ? (
        <video
          src={item.url}
          className={styles.media}
          controls
          controlsList="nodownload noremoteplayback"
          disablePictureInPicture
          playsInline
          preload="metadata"
        />
      ) : (
        <img
          src={item.url}
          alt={item.title || 'Contenido'}
          className={styles.media}
          draggable={false}
        />
      )}
      <div className={styles.watermark} aria-hidden="true">
        {watermarkText}
      </div>
    </div>
  );
};

export default MediaWatermark;
